// modules
import React, { Suspense, lazy } from 'react'

// components
import { Spin } from '@emmacare/common/design-system/components/Spin'

const LazyImport = (ImportedComponent) => {
  const Component = lazy(ImportedComponent)

  return (props) => (
    <Suspense
      fallback={
        <div
          style={{ height: '100vh', display: 'flex', justifyContent: 'center' }}
        >
          <Spin size="large" />
        </div>
      }
    >
      <Component {...props} />
    </Suspense>
  )
}

export default LazyImport
